import React from "react";
import { Form, Collapse, Button } from "react-bootstrap";
import Select from "react-select";
import "../App.scss";
import { updateState } from "../page/StateHelper";
import BuyerApi from "../api/BuyerApi";

let initialState = {
    magic: 0,
    orderNumbersAsStr: '',
    orderNumbers: new Array(),

    // 🔥 MÜŞTERİ SEÇİM STATE'LERİ
    buyerOptions: [], // API'den çekilip Select formatına dönüştürülen liste
    selectedBuyers: [], // Kullanıcının seçtiği objeler
    buyerIds: new Array(), // Backend'e filtre olarak gidecek ID dizisi
    isBuyersLoading: false,

    orderStatus: "IN_PROGRESS",
    orderStatuses: ["IN_PROGRESS"],
    timePeriod: 1,
    fromCreateDate: null,
    toCreateDate: null,
    fromPlannedShipmentDate: '',
    toPlannedShipmentDate: '',
    buyerRequestReferenceCode: '',

    // 🔥 UI STATE'İ
    showAdvancedFilters: false
}

class OrderQueryFilter extends React.Component<any, any> {

    constructor(props: any) {
       super(props);
       this.state = initialState;
       this.magicSetState = this.magicSetState.bind(this);
       this.onChangeFor = this.onChangeFor.bind(this);
       this.reset = this.reset.bind(this);
       this.search = this.search.bind(this);
       this.handleBuyerChange = this.handleBuyerChange.bind(this);
       this.fetchBuyersList = this.fetchBuyersList.bind(this);
    }

    componentDidMount() {
          let end = new Date();
          let start = new Date();
          start.setDate(start.getDate() -  this.state.timePeriod);
          updateState(this,"fromCreateDate", start);
          updateState(this,"toCreateDate", end);
          this.props.onQuery({query:this.state});

          this.fetchBuyersList();
    }

    async fetchBuyersList() {
        this.setState({ isBuyersLoading: true });

        try {
            const response = await BuyerApi.listAllCards();

            if (response && response.success && response.data) {
                const options = response.data.map((buyer: any) => ({
                    value: buyer.id,
                    label: buyer.title || buyer.name || buyer.code || `Bilinmeyen Müşteri (${buyer.id})`
                }));

                this.setState({ buyerOptions: options });
            }
        } catch (error) {
            console.error("Müşteri listesi çekilirken hata oluştu:", error);
        } finally {
            this.setState({ isBuyersLoading: false });
        }
    }

    magicSetState(state:any) {
       updateState(this, "magic", Math.random());
       this.setState(state);
    }

    onChangeFor(field:any, e:any) {
       updateState(this, field, e.target.value);
    }

    handleBuyerChange(selectedOptions: any) {
        updateState(this, "selectedBuyers", selectedOptions);

        const ids = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
        updateState(this, "buyerIds", ids);
    }

    reset() {
       const currentOptions = this.state.buyerOptions;
       this.magicSetState({ ...initialState, buyerOptions: currentOptions });
    }

    search() {
       if(this.state.orderNumbersAsStr) {
          updateState(this, "orderNumbers", [parseInt(this.state.orderNumbersAsStr)]);
       } else {
          updateState(this, "orderNumbers", []);
       }

       if(this.state.orderStatus) {
          if(this.state.orderStatus === "ALL") {
             updateState(this, "orderStatuses", new Array());
          } else {
             updateState(this, "orderStatuses", this.state.orderStatus.split(","));
          }
       }

       if(this.state.timePeriod) {
          let end = new Date();
          let start = new Date();
          start.setDate(start.getDate() -  this.state.timePeriod);
          updateState(this,"fromCreateDate", start);
          updateState(this,"toCreateDate", end);
       }

       this.props.onQuery({query:this.state});
    }

    render() {
       return (
          <div className="container zero-div mb-3 p-3 bg-white rounded shadow-sm border">

             {/* ==========================================
                 1. SATIR: TEMEL FİLTRELER
                 ========================================== */}
             <div className="row align-items-end">
                <div className="col-md-3">
                   <label className="form-label text-muted small fw-bold mb-1">Sipariş Durumu</label>
                   <Form.Select
                      size="sm"
                      name="orderStatus"
                      value={this.state.orderStatus}
                      onChange={(e:any) => this.onChangeFor("orderStatus", e)}
                   >
                      <option value="WAITING_FOR_REVIEW,IN_REVIEW">Gözden Geçiriliyor</option>
                      <option value="IN_PROGRESS">İşleme Alındı, Devam Ediyor</option>
                      <option value="CANCELED_BY_SELLER">Satıcı Tarafından İptal Edildi</option>
                      <option value="CANCELED_BY_BUYER">Alıcı Tarafından İptal Edildi</option>
                      <option value="COMPLETED">Tamamlandı</option>
                      <option value="ALL">Tümü</option>
                   </Form.Select>
                </div>

                <div className="col-md-2">
                   <label className="form-label text-muted small fw-bold mb-1">Sipariş Tarihi</label>
                   <Form.Select
                      size="sm"
                      name="timePeriod"
                      value={this.state.timePeriod}
                      onChange={(e:any) => this.onChangeFor("timePeriod", e)}
                   >
                      <option value="1">Son 24 Saat</option>
                      <option value="7">Son 7 Gün</option>
                      <option value="30">Son 1 Ay</option>
                      <option value="90">Son 3 Ay</option>
                   </Form.Select>
                </div>

                <div className="col-md-4">
                   <label className="form-label text-muted small fw-bold mb-1">Müşteriler</label>
                   <Select
                        isMulti
                        name="buyers"
                        options={this.state.buyerOptions}
                        isLoading={this.state.isBuyersLoading}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder={this.state.isBuyersLoading ? "Yükleniyor..." : "Müşteri Ara & Seç..."}
                        noOptionsMessage={() => "Müşteri bulunamadı"}
                        value={this.state.selectedBuyers}
                        onChange={this.handleBuyerChange}
                        styles={{
                            control: (base: any) => ({ ...base, minHeight: '31px', fontSize: '14px' }),
                            dropdownIndicator: (base: any) => ({ ...base, padding: '4px' }),
                            clearIndicator: (base: any) => ({ ...base, padding: '4px' }),
                        }}
                    />
                </div>

                <div className="col-md-3 d-flex justify-content-end">
                    <Button
                        variant="link"
                        size="sm"
                        className="text-decoration-none me-2 text-muted"
                        onClick={() => this.setState({ showAdvancedFilters: !this.state.showAdvancedFilters })}
                    >
                        <i className={`fa ${this.state.showAdvancedFilters ? 'fa-chevron-up' : 'fa-chevron-down'} me-1`}></i>
                        {this.state.showAdvancedFilters ? 'Gizle' : 'Gelişmiş'}
                    </Button>

                    <Button variant="secondary" size="sm" onClick={this.reset} className="me-2">
                        Temizle
                    </Button>
                    <Button variant="primary" size="sm" onClick={this.search}>
                        Ara
                    </Button>
                </div>
             </div>

             {/* ==========================================
                 2. BÖLÜM: GELİŞMİŞ FİLTRELER
                 ========================================== */}
             <Collapse in={this.state.showAdvancedFilters}>
                <div className="mt-3 pt-3 border-top">
                    <div className="row">
                        <div className="col-md-3 mb-2">
                            <label className="form-label text-muted small mb-1">Sipariş No</label>
                            <Form.Control size="sm" name="orderNumbersAsStr" type="text" placeholder="Örn: 69815628" value={this.state.orderNumbersAsStr} onChange={(e:any) => this.onChangeFor("orderNumbersAsStr" , e)}/>
                        </div>

                        <div className="col-md-3 mb-2">
                            <label className="form-label text-muted small mb-1">Son Teslim Tarihi (Başlangıç)</label>
                            <Form.Control size="sm" name="fromPlannedShipmentDate" type="date" value={this.state.fromPlannedShipmentDate} onChange={(e:any) => this.onChangeFor("fromPlannedShipmentDate" , e)}/>
                        </div>

                        <div className="col-md-3 mb-2">
                            <label className="form-label text-muted small mb-1">Son Teslim Tarihi (Bitiş)</label>
                            <Form.Control size="sm" name="toPlannedShipmentDate" type="date" value={this.state.toPlannedShipmentDate} onChange={(e:any) => this.onChangeFor("toPlannedShipmentDate" , e)}/>
                        </div>

                        <div className="col-md-3 mb-2">
                            <label className="form-label text-muted small mb-1">Müşteri Talep Ref</label>
                            <Form.Control size="sm" name="buyerRequestReferenceCode" type="text" placeholder="Ref Kodu" value={this.state.buyerRequestReferenceCode} onChange={(e:any) => this.onChangeFor("buyerRequestReferenceCode" , e)}/>
                        </div>
                    </div>
                </div>
             </Collapse>

             {this.props.children}
          </div>
       );
    }
}

export default OrderQueryFilter;